const faqSchema = (faqs = []) => {
  if (!faqs.length) return {};
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage'
  };

  schema.mainEntity = faqs.map((faq) => [
    {
      '@type': 'Question',
      name: faq.key,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.value
      }
    }
  ]);
  return schema;
};

export default faqSchema;
